import { createFileRoute } from '@tanstack/react-router'
import { ExamEditorPage } from '@/features/exams/editor'

export const Route = createFileRoute('/exams_/new')({
  component: ExamEditorPage,
})
